import { connect } from 'react-redux'
import { SignupFormComponent } from './SignupFormComponent'
import {
    fetchSignupPageData,
    resendMail,
    resetSignup,
    sendSignupForm
} from 'shared/store/signup'
import type { RootState } from 'shared/store/reducers'
import type { Dispatch } from 'redux'
import type { SignUpForm } from 'shared/types'
import { push } from 'connected-react-router'
import { clearSigninRedirect } from 'shared/store/signin'

const mapStateToProps = (state: RootState) => {
    return {
        ...state.signupPageState,
        ...state.userState,
        redirectToAfterLogin: state.signinPageState.redirectToAfterLogin
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    signup: (form: SignUpForm) => d(sendSignupForm(form)),
    reset: () => d(resetSignup()),
    navigate: (to: string) => d(push(to)),
    resendMail: (queen: string) => d(resendMail(queen)),
    fetchSignupPageData: () => d(fetchSignupPageData()),
    goToRedirectAndReset: (url: string) => {
        d(clearSigninRedirect())
        d(push(url))
    }
})

const SignupForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(SignupFormComponent)

export { SignupForm }
